import { emptyArr } from 'util/arrays'

const selectGroups = state => state.groups || emptyArr

export default selectGroups
